import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsAndConditions = () => {
    return (
        <div className="bg-background">
            {/* Header */}
            <div className="bg-primary py-16">
                <div className="section-container">
                    <Link to="/" className="inline-flex items-center gap-2 text-primary-foreground/80 hover:text-primary-foreground mb-6 transition-colors">
                        <ArrowLeft className="w-4 h-4" />
                        Back to Home
                    </Link>
                    <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-primary-foreground">Terms & Conditions</h1>
                    <p className="text-primary-foreground/80 mt-4">Last updated: November 07, 2024</p>
                </div>
            </div>

            {/* Content */}
            <div className="section-container py-16">
                <div className="max-w-4xl mx-auto prose prose-lg">
                    <p className="text-muted-foreground leading-relaxed">
                        Please read these Terms and Conditions carefully before using our Service.
                    </p>

                    <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">Interpretation and Definitions</h2>
                    
                    <h3 className="text-xl font-semibold text-foreground mt-8 mb-3">Interpretation</h3>
                    <p className="text-muted-foreground leading-relaxed">
                        Words with capitalized initial letters have meanings defined under the following conditions and apply whether used in singular or plural.
                    </p>

                    <h3 className="text-xl font-semibold text-foreground mt-8 mb-3">Definitions</h3>
                    <ul className="list-disc list-inside text-muted-foreground space-y-2">
                        <li><strong className="text-foreground">Affiliate:</strong> Entity under common control with the Company</li>
                        <li><strong className="text-foreground">Country:</strong> Madhya Pradesh, India</li>
                        <li><strong className="text-foreground">Company:</strong> Dhakad Enterprises, Devalkhedi Jhod Jadgdishpur Islam Nagar Road, Bhopal, MP 462038</li>
                        <li><strong className="text-foreground">Device:</strong> Any device capable of accessing the Service</li>
                        <li><strong className="text-foreground">Service:</strong> The Website operated by the Company</li>
                        <li><strong className="text-foreground">Website:</strong> <a href="https://dhakadenterprises.in/" className="text-primary hover:underline">https://dhakadenterprises.in/</a></li>
                        <li><strong className="text-foreground">You:</strong> Individual or entity accessing the Service</li>
                    </ul>

                    <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">Acknowledgment</h2>
                    <p className="text-muted-foreground leading-relaxed">
                        These Terms govern Your use of the Service and constitute a binding agreement between You and the Company.
                    </p>
                    <p className="text-muted-foreground leading-relaxed mt-4">
                        By accessing or using the Service, You agree to be bound by these Terms. If You do not agree, You must discontinue use of the Service.
                    </p>
                    <p className="text-muted-foreground leading-relaxed mt-4">
                        You confirm that You are at least 18 years of age.
                    </p>

                    <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">Links to Other Websites</h2>
                    <p className="text-muted-foreground leading-relaxed">
                        Our Service may contain links to third-party websites not controlled by the Company. We are not responsible for their content or policies.
                    </p>

                    <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">Termination</h2>
                    <p className="text-muted-foreground leading-relaxed">
                        We may terminate or suspend Your access immediately without notice if You violate these Terms.
                    </p>

                    <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">Limitation of Liability</h2>
                    <p className="text-muted-foreground leading-relaxed">
                        The Company's total liability shall be limited to the amount paid by You or USD 100 if no purchase was made.
                    </p>
                    <p className="text-muted-foreground leading-relaxed mt-4">
                        In no event shall the Company be liable for indirect, incidental, or consequential damages.
                    </p>

                    <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">"AS IS" and "AS AVAILABLE" Disclaimer</h2>
                    <p className="text-muted-foreground leading-relaxed">
                        The Service is provided "AS IS" without warranties of any kind, including implied warranties of merchantability or fitness for a particular purpose.
                    </p>

                    <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">Governing Law</h2>
                    <p className="text-muted-foreground leading-relaxed">
                        These Terms shall be governed by the laws of Madhya Pradesh, India.
                    </p>

                    <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">Dispute Resolution</h2>
                    <p className="text-muted-foreground leading-relaxed">
                        You agree to attempt informal resolution by contacting the Company before pursuing formal legal action.
                    </p>

                    <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">Severability and Waiver</h2>
                    <p className="text-muted-foreground leading-relaxed">
                        If any provision is found unenforceable, the remaining provisions shall remain in full force.
                    </p>

                    <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">Changes to These Terms</h2>
                    <p className="text-muted-foreground leading-relaxed">
                        We reserve the right to modify these Terms at any time. Continued use of the Service constitutes acceptance of the updated Terms.
                    </p>

                    <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">Contact Us</h2>
                    <ul className="list-disc list-inside text-muted-foreground space-y-2">
                        <li><strong className="text-foreground">Email:</strong> <a href="mailto:Prashantdhakad12345@gmail.com" className="text-primary hover:underline">Prashantdhakad12345@gmail.com</a></li>
                        <li><strong className="text-foreground">Website:</strong> <a href="https://dhakadenterprises.in/" className="text-primary hover:underline">dhakadenterprises.in</a></li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default TermsAndConditions;
